var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"message"},[_vm._v("Site Under Construction")]),_c('p',[_c('a',{attrs:{"href":"mailto:icpc2t_2022@nitrr.ac.in"}},[_vm._v("icpc2t_2022@nitrr.ac.in")])])])
}]

export { render, staticRenderFns }